export class VRMRequest {
        constructor(
                public VRM: string,
                public incValuation: boolean = false,
                public mileage: number = null,
                public condition:string = null
        ) { }
}